import $ from "../../vendor/jquery-1.11.2";

function createImageFromTemplate(template_selector, tag_selector) {
    let clone = cloneFromTemplate(template_selector);
    const tag = document.querySelector(tag_selector);
    tag.appendChild(clone);
}

export function populateImage(that, output_selector, src=null) {
    if (src || (that && that.files) ) {
        let image = document.querySelector(output_selector);
        image.src = src ? src : window.URL.createObjectURL(that.files[0]);
    }
}

function resetImage(output_selector) {
    document.querySelector(output_selector).src = null;
}

function populateStickerGroup(template_selector, accordion_selector, sticker_group_item) {
    let clone = cloneFromTemplate(template_selector);
    let id = 'sticker-' + sticker_group_item.id;
    let group = clone.querySelector('.accordion-toggle');
    group.href = '#' + id;
    group.innerHTML = sticker_group_item.name

    clone.querySelector('.accordion-body').id = id;

    let inner = clone.querySelector('.accordion-inner');
    $.each(sticker_group_item.sticker_list, function (i, item) {
        let sticker_item = sticker('#sticker-item', sticker_group_item.name, item, id);
        inner.appendChild(sticker_item);
    });

    const accordion = document.querySelector(accordion_selector);
    accordion.appendChild(clone);
}

function sticker(template_selector, group, sticker_item, parent_id) {
    let clone = cloneFromTemplate(template_selector);
    let id = parent_id + '-' + sticker_item.id;
    clone.querySelector('.well').id = id;

    let checkbox = clone.querySelector('.selected-sticker')
    checkbox.dataset.index = sticker_item.id;
    checkbox.dataset.id = id;
    checkbox.id = 'checkbox-' + id;

    let deleteButton = clone.querySelector('.btn-delete-sticker');
    deleteButton.dataset.index = sticker_item.id;
    deleteButton.dataset.id = id;
    deleteButton.id = 'delete-button-' + id;
    deleteButton.onclick = function (event) {
        deleteSticker(sticker_item.id);
    };

    clone.querySelector('.sticker-img').src = sticker_item.url
    let radio_buttons = clone.querySelectorAll('.sticker-gravity');
    $(radio_buttons).each(function(i, radio_button) {
        radio_button.id = radio_button.id + '-' + group + '-' + sticker_item.id
        radio_button.dataset['id'] = id;
        radio_button.dataset['idx'] = sticker_item.id;
        radio_button.dataset['group'] = group;
        radio_button.dataset['parent'] = template_selector;
    });

    let number_fields = clone.querySelectorAll('.sticker-offset');


    $(number_fields).each(function(i, number_field) {
        number_field.id = number_field.id + '-' + group + '-' + sticker_item.id
        number_field.dataset['id'] = id;
        number_field.dataset['idx'] = sticker_item.id;
        number_field.dataset['group'] = group;
        number_field.dataset['parent'] = template_selector;
        number_field.dataset['axis'] = number_field.id.includes('offset_x') ? 'x' : 'y';
    });

    for (let key of Object.keys(window.editor_settings.stickers)) {
        if (window.editor_settings.stickers[key] &&
            window.editor_settings.stickers[key].id === sticker_item.id &&
            window.editor_settings.stickers[key].group === group) {
            $(checkbox).click();
            $(radio_buttons).attr('disabled', false);
            let checked_radio_button = clone.querySelectorAll('.sticker-gravity-' + key)
            $(checked_radio_button).click();
        }
    }

    return clone;
}

export function populateStickers() {
    $.getJSON(window.editor_paths.stickers.get)
        .done(function (data) {
            $.each(data, function (i, item) {
                if (item.sticker_list.length > 0) {
                    populateStickerGroup('#sticker-group-item', '#sticker-list', item);
                }
            });
        });
}

export function initEditor() {
    createImageFromTemplate('#template-' + window.current_image_orientation, '#image-source');
    createImageFromTemplate('#template-' + window.current_image_orientation, '#image-processed');
    setEditorImageDimensions();
    populateCurrentImage();
}

export function uploadSticker(that) {
    let formData = new FormData();

    let image = $('#sticker-file-field')[0].files[0];
    formData.append('image', image);

    let groups = $('#sticker_groups').val();
    formData.append('groups', groups);

    let url = $(that).attr('action');

    $.ajax({
        url: url,
        type: 'POST',
        beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
        data: formData,
        processData: false,
        contentType: false,
        success: function(response) {
            that.reset();
            resetImage('#sticker-image');
            $('#sticker_groups').tagsinput('removeAll');
            $('#sticker-list').html('');
            populateStickers();
        },
        error: function(xhr, status, error) {
            console.error('Error uploading image:', error);
            console.log(status);
            console.log(xhr);
        }
    });
}

export function deleteSticker(stickerId) {
    let baseUrl = window.location.origin;
    console.log('baseUrl', baseUrl);
    let url = `${baseUrl}/admin/stickers/${stickerId}`;

    // Show confirmation dialog before deleting
    if (!window.confirm('Are you sure you want to delete this sticker?')) {
        return;
    }

    $.ajax({
        url: url,
        type: 'DELETE',
        beforeSend: function (xhr) {
            xhr.setRequestHeader(
                'X-CSRF-Token',
                $('meta[name="csrf-token"]').attr('content')
            );
        },
        data: null,
        processData: false,
        contentType: false,
        success: function (response) {
            resetImage('#sticker-image');
            $('#sticker_groups').tagsinput('removeAll');
            $('#sticker-list').html('');
            populateStickers();
        },
        error: function (xhr, status, error) {
            console.error('Error deleting image:', error);
            console.log(status);
            console.log(xhr);
        },
    });
}

export function cloneFromTemplate(template_selector) {
    const template = document.querySelector(template_selector);
    return template.content.cloneNode(true);
}

function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

export function processStickerGravity(that) {
    let data = $(that).data();
    let sticker = {
        id: data.idx,
        gravity: that.value,
        group: data.group,
        offset: {
            x: $('#offset_x-' + data.group + '-' + data.idx).val(),
            y: $('#offset_y-' + data.group + '-' + data.idx).val()
        }
    };

    for (let key of Object.keys(window.editor_settings.stickers)) {
        if (window.editor_settings.stickers[key] && window.editor_settings.stickers[key].id === sticker.id) {
            window.editor_settings.stickers[key] = null;
        }
    }

    if(that.checked) {
        if (window.editor_settings.stickers[data.gravity]) {
            if (window.confirm("Do you really want to replace the existing sticker on this position?")) {
                window.editor_settings.stickers[data.gravity] = sticker;
            } else {
                that.checked = false;
            }
        } else {
            window.editor_settings.stickers[data.gravity] = sticker;
        }
    }
}

export function processStickerOffset(that) {
    let data = $(that).data();
    for (let key of Object.keys(window.editor_settings.stickers)) {
        if (window.editor_settings.stickers[key] && window.editor_settings.stickers[key].id === data.idx) {
            window.editor_settings.stickers[key].offset[data.axis] = that.value;

        }
    }
}

export function processSticker(that) {
    let data = $(that).data();
    let parent = document.getElementById(data.id);
    let checkboxes = parent.querySelectorAll('.sticker-gravity');
    let $grand_parent = $(that).parent().parent();
    let $settings_group = $grand_parent.find('.sticker-settings');
    let $offset_inputs = $grand_parent.find('.sticker-offset');
    if(that.checked) {
        $(checkboxes).attr('disabled', false);
        $offset_inputs.attr('disabled', false);
        $settings_group.show();
    } else {
        $settings_group.hide();
        $offset_inputs.attr('disabled', true);
        $offset_inputs.val(0);
        $(checkboxes).attr('disabled', true);
        $(checkboxes).attr('checked', false);
    }
}

export function imageProcessing() {
    if(window.editor_settings.source) {
        $.ajax({
            url: window.editor_paths.images.create,
            type: 'POST',
            beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
            data: createProcessingParams(),
            processData: false,
            contentType: false,
            success: function(response) {
                populateImage(null, '#image-processed img', response.url);
                if ( window.editor_settings.assign ) {
                    let image = imageData(this)
                    updateCurrentImage(response, image);
                }
            },
            error: function(xhr, status, error) {
                console.error('Error processing image:', error);
                console.log(status);
                console.log(xhr);
                alert('Error: ' + xhr.responseText);
            }
        });
    } else {
        alert('you need to have a source image');
    }
}

function parse_query_string(query) {
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair.shift());
        var value = decodeURIComponent(pair.join("="));
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
            query_string[key] = value;
            // If second entry with this name
        } else if (typeof query_string[key] === "string") {
            var arr = [query_string[key], value];
            query_string[key] = arr;
            // If third or later entry with this name
        } else {
            query_string[key].push(value);
        }
    }
    return query_string;
}

export function initEditorSettings() {
    let query = window.location.search.substring(1);
    let qs = parse_query_string(query);
    window.editor_settings = {
        object_type: qs['object_type'] ? qs['object_type'] : null,
        object_id: qs['object_id'] ? qs['object_id'] : null,
        image_type: qs['image_type'] ? qs['image_type'] : null,
        locale: qs['locale'] ? qs['locale'] : null,
        globalize: ( qs['globalize'] === 'true' || qs['globalize'] === true || qs['globalize'] === '1' || qs['globalize'] === 1 ),
        source: null,
        new: false,
        assign: false,
        stickers: {
            nw: null,
            n: null,
            ne: null,
            w: null,
            c: null,
            e: null,
            sw: null,
            s: null,
            se: null
        }
    };
}

export function populateCurrentImage(url=null) {
    if (url) {
        window.current_image = url;
    }
    if (window.current_image) {
        window.editor_settings.source = window.current_image;
        populateImage(null, '#image-source img', window.current_image);
        populateImage(null, '#image-processed img', window.current_image);

    }
}

export function setEditorImageDimensions() {
    let proportion = window.current_image_orientation === 'portrait' ? 1.2 : 2;
    let $source = $('#image-source img');
    let $processed = $('#image-processed img');
    let height = $source.height() * proportion;
    let width = $source.width() * proportion;

    $source.height(height).width(width);
    $processed.height(height).width(width);
}

function createProcessingParams() {
    let formData = new FormData();
    for (let key of Object.keys(window.editor_settings)) {
        let value = window.editor_settings[key];
        if (key === 'stickers') {
            for (let stickersKey in value) {
                if (value && value !== 'null') {
                    for (let stickerKey in value[stickersKey]) {
                        if (stickerKey === 'offset') {
                            for (let offsetKey in value[stickersKey][stickerKey]) {
                                formData.append(`content_image[${key}][${stickersKey}][${stickerKey}][${offsetKey}]`, value[stickersKey][stickerKey][offsetKey]);
                            }
                        } else {
                            formData.append(`content_image[${key}][${stickersKey}][${stickerKey}]`, value[stickersKey][stickerKey]);
                        }
                    }
                }
            }
        } else {
            formData.append(`content_image[${key}]`, value);
        }
    }

    return formData;
}

function imageAjaxRequest(url, method, image, delegation) {
    $.ajax({
        url: url,
        type: method,
        beforeSend: function(xhr) {
            xhr.setRequestHeader(
                'X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')
            )},
        data: createImageParams(image.data),
        processData: false,
        contentType: false,
        success: function(response) {
            delegation(response, image);
        },
        error: function(xhr, status, error) {
            console.error('Error:', error);
            console.log(status);
            console.log(xhr);
            alert('Error: ' + xhr.responseText);
        }
    });
}
export function scheduleImage(that) {
    let image = imageData(that);
    let schedule_at = window.parent.scheduleAtVal();
    if ( schedule_at ) {
        image.data.published_at = schedule_at;
        let url = window.editor_paths.images.schedule.replace(':id', image.data.id);
        imageAjaxRequest(url, 'POST', image, successfulScheduleImage);
    } else {
        alert('schedule at date is required');
    }
}

function successfulScheduleImage(response, image) {
    if ( response ) {
        if ( response.schedule && response.schedule ) {
            let schedule = `<div class="row-fluid"><span class="label label-important">${response.schedule}</span></div>`;
            $('#schedules-' + image.data.id).append(schedule);
        }

        if ( response.count  ) {
            $('#schedules-' + image.data.id + '-count').text(response.count);
        }

        $('#schedules-' + image.data.id + '-collapse').show();
    }
}

export function assignImage(that) {
    let image = imageData(that);
    let url = window.editor_paths.images.assign.replace(':id', image.data.id);
    imageAjaxRequest(url, 'POST', image, successfulAssignImage);
}

function successfulAssignImage(response, image) {
    updateCurrentImage(response, image);
}

function updateCurrentImage(response, image) {
    if ( response && response.success ) {
        window.parent.updateAssignedImage('#' + image.qs['image_id'], response.url)
        window.parent.CloseModal(window.frameElement);
    }
}

export function editImage(that) {
    let image = imageData(that);
    populateCurrentImage(image.data.url);
    $('#create_image_collapse').click();
}

export function destroyImage(that) {
    let image = imageData(that);
    let url = window.editor_paths.images.destroy.replace(':id', image.data.id);
    imageAjaxRequest(url, 'DELETE', image, successfulDestroyImage);
}

function successfulDestroyImage(response, image) {
    if ( response && response.success ) {
        let id = image.data.model + '_'+ image.data.id + '_' + image.data.imageType;
        if (image.data.model === 'content_image') {
            id += '_row';
        }

        let $element = $('#' + id)
        if ( $element.length > 0 ) {
            $element.remove();
        }
    }
}

function createImageParams(data) {
    let formData = new FormData();

    for (let key of Object.keys(data)) {
        formData.append(`${data.model}[${underscore(key)}]`, data[key]);
    }

    return formData;
}

function imageData(that) {
    let query = window.location.search.substring(1);
    return {
        data: $(that).data(),
        qs: parse_query_string(query)
    };
}

function underscore(string) {
    return string.split(/\.?(?=[A-Z])/).join('_').toLowerCase();
}
